module.exports = __webpack_public_path__ + "static/media/s_v8_t7_2.9aeacc90.mp3";